export default {
    dateConfig: {
        locale: 'ja',
        format: 'YYYY/MM/DD(ddd)',
    },
    dateTimeConfig: {
        locale: 'ja',
        format: 'YYYY/MM/DD(ddd) H:mm',
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/const/admin/dateConfig.js